// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetBannerEnrichmentsRequest,
  TGetBannerEnrichmentsModel,
  IMappers,
  TGetBannerEnrichmentsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetBannerEnrichmentsV1Response } from '../../entities/get_banner_enrichments_v1/GetBannerEnrichmentsV1Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetBannerEnrichmentsModel(parameters: TGetBannerEnrichmentsRequest): TGetBannerEnrichmentsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'ad-banner',
    pathApi: '/v1/get-banner-enrichments/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetBannerEnrichmentsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetBannerEnrichmentsRequest;
}

export async function fetchGetBannerEnrichments<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetBannerEnrichmentsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetBannerEnrichmentsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetBannerEnrichmentsModel(parameters),
    config,
  )) as FetchResponse<TGetBannerEnrichmentsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetBannerEnrichmentsV1Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetBannerEnrichmentsResponse>;
}
